import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { validateConfig } from './lib';
import { Provider } from 'react-redux';
import configureStore from './store/configure-store';
import tracking from './tracking';

let context = (window as any) || {};

context.GetQuote = (function () {
    function boostrapApplication(config: any, boostrapElement: any) {
        //console.log('config', config);
        const store = configureStore(config);
        tracking.setHandler(config.trackingHandler);
        ReactDOM.render(
            <Provider store={store}>
                <App config={config} />
            </Provider>,
            boostrapElement,
            () => validateConfig(config, store)
        );
    }

    return boostrapApplication;
})();
